import { render } from "./FeaturesHome.vue?vue&type=template&id=5a9866b2&scoped=true"
import script from "./FeaturesHome.vue?vue&type=script&lang=js"
export * from "./FeaturesHome.vue?vue&type=script&lang=js"

import "./FeaturesHome.vue?vue&type=style&index=0&id=5a9866b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9866b2"]])

export default __exports__